
import { ImplementationStateEnum, PermissionTypeEnum } from '@/libs/Api';
import { Component, Prop, VModel } from 'vue-property-decorator';
import { PermissionsHelper } from '@/libs/core/permissions-helper';
import Page from '@/Page.vue';

@Component({})
export default class ImplementationStateToggle extends Page {
    protected ImplementationStateEnum: typeof ImplementationStateEnum = ImplementationStateEnum;
    protected PermissionTypeEnum: typeof PermissionTypeEnum = PermissionTypeEnum;

    get items() {
        if (this.canBeVerified) {
            return [
                { id: ImplementationStateEnum.New, name: this.$i18n.t('issueDialog.new') },
                { id: ImplementationStateEnum.InProgress, name: this.$i18n.t('issueDialog.inProgress') },
                {
                    id: ImplementationStateEnum.WaitingForVerification,
                    name: this.$i18n.t('issueDialog.performedSendToVerification'),
                },
                { id: ImplementationStateEnum.Verified, name: this.$i18n.t('issueDialog.verifiedWhenPerformed') },
            ];
        } else {
            return [
                { id: ImplementationStateEnum.New, name: this.$i18n.t('issueDialog.new') },
                { id: ImplementationStateEnum.InProgress, name: this.$i18n.t('issueDialog.inProgress') },
                { id: ImplementationStateEnum.WaitingForVerification, name: this.$i18n.t('issueDialog.performed') },
            ];
        }
    }

    @VModel() innerValue!: string;
    @Prop({ default: '' }) label!: string;
    @Prop({ default: false }) mandatory!: boolean;
    @Prop({ default: false }) canBeVerified!: boolean;
    @Prop({ default: null }) categoryId!: string | null; // ✅ NOVÝ SYSTÉM: CategoryId pro kontrolu oprávnění
}
